/* eslint-disable */

import { useEffect, useState } from 'react'
import scanner from '../../../src/assets/PaymentGateway/document_scanner.svg'
import spark from '../../assets/PaymentGateway/spark.svg'
import account from '../../assets/PaymentGateway/account_balance.svg'
import additionalImage from '../../assets/PaymentGateway/account_balance_blue.svg'
import tick from '../../assets/PaymentGateway/Frame 354190.svg'
import { Button } from '../../Components/ui/button'
import { useLocation, useNavigate } from 'react-router-dom'
import PaymentStatusModal from '../../Components/modals/OneTimePayment'
import { get, post } from '../../http/restservice'
import { Input } from '../../Components/ui/input'
import { AlertCircleIcon, ChevronLeft, FileText } from 'lucide-react'
import { messageModalState } from '../../store/Feedback'
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil'
import { BankDetails } from '../../store/AccountDetailsStore'
import env from '../../env/env'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { toCurrency } from '../../utils/CurrencyUtil'
import ActionPlanUpiRequest from './ActionPlanUpiRequest'
import { AccountBalance } from '@mui/icons-material'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../Components/ui/alert-dialog'
import OrderOtpVerification from './OrderOtpVerification'
import { userDetailsState } from '../LoginState'
import { formatIndianNumber } from '../../utils/Util'

const BankAccountItem = ({ bank, isSelected, onSelect, tickIcon, bankLogosUrl }) => {

  const [iconSrc, setIconSrc] = useState(() => {
    const branch = bank.ifscCode?.match(/^[A-Za-z]{4}/)?.[0]?.toLowerCase()
    return branch ? `${bankLogosUrl}/${branch}/symbol.svg` : null
  })
  return (
    <div
      onClick={(e) => { e.stopPropagation(); onSelect(bank.accountNo) }}
      className={`w-full p-4 flex items-center gap-4 rounded-[16px] cursor-pointer transition-all duration-200 ease-in-out border ${isSelected ? 'border-primary-500 bg-primary-50' : 'border-transparent hover:bg-[#ecf0f4]'}`}
    >
      <div className='flex-shrink-0'>
        {iconSrc ? (
          <img
            src={iconSrc}
            alt='bank logo'
            onError={() => setIconSrc(null)}
            height={24}
            width={24}
          />
        ) : (
          <AccountBalance className='text-primary-200' />
        )}
      </div>
      <div className='flex flex-col'>
        <span className='text-[#2f3c5a] font-semibold'>{bank.accountHolderName}</span>
        <span className='text-[#2f3c5a] text-xs'>
          {bank.bankName} A/c ending in <strong> {bank.accountNo?.slice(-4)}</strong>
        </span>
      </div>
      <div className={`ml-auto flex-shrink-0 transition-opacity duration-200 ease-in-out ${isSelected ? 'opacity-100' : 'opacity-0'}`}>
        <div className='w-6 h-6 flex items-center justify-center'>
          <img src={tickIcon} alt='tick' />
        </div>
      </div>
    </div>
  )
}

const MFBasketOneTimePayment = () => {
  const location = useLocation()
  const [paymentPayload, setPaymentPayload] = useState(location?.state?.paymentPayload)
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)

  const clientCode = paymentPayload?.clientCode
  const navigate = useNavigate()
  const { showError, onClose } = useErrorPopup()
  const userData = JSON.parse(localStorage.getItem('userData'))
  const [upiId, setUpiId] = useState(userData?.upiId || '')
  const [isLoading, setIsLoading] = useState(false)
  const setMessageModalState = useSetRecoilState(messageModalState)
  const { contents: bankDetails } = useRecoilValueLoadable(BankDetails)
  const [showPaymentRequestPopup, setShowPaymentRequestPopup] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [responseString, setResponseString] = useState('')
  const [orderNo, setOrderNo] = useState([])
  const [verifyCheque, setVerifyCheque] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [modalData, setModalData] = useState({})
  const [openOTPPopup, setOpenOTPPopup] = useState(false)
  // Stores only approved mandates from the mandates API response
  const [mandateDetails, setMandateDetails] = useState([])

  const [selectedBank, setSelectedBank] = useState(null)

  // Support multiple bank accounts from API response
  const bankAccountsList = (() => {
    const accounts = []

    // If banks array exists, use it (new API format)
    if (Array.isArray(bankDetails?.banks) && bankDetails?.banks.length > 0) {
      bankDetails.banks.forEach((bank) => {
        accounts.push({
          accountNo: bank.accountNo,
          bankName: bank.bankName,
          ifscCode: bank.ifscCode,
          accountHolderName: bank.accountHolderName || bankDetails?.accountHolderName,
        })
      })
    }
    // Fallback to single bank account (backward compatibility)
    else if (bankDetails?.accountNo) {
      accounts.push({
        accountNo: bankDetails.accountNo,
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
      })
    }

    return accounts
  })()

  // Auto-select bank when there's only one account (for all non-cash flows including UPI)
  useEffect(() => {
    if (bankAccountsList.length === 1 && selectedOption) {
      setSelectedBank(bankAccountsList[0].accountNo)
    }
  }, [selectedOption, bankDetails])

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  useEffect(() => {
    getMandateDetails()
  }, [paymentPayload?.lumpsumAmount])

  const primaryBankName = bankDetails?.bankName?.toUpperCase() || ''
  const primaryIfsc = bankDetails?.ifscCode?.toUpperCase() || ''

  const disableNetBanking =
    primaryBankName?.includes('DBS') ||
    primaryBankName?.includes('DEVELOPMENT BANK OF SINGAPORE') ||
    primaryBankName?.includes('DIGI BANK') ||
    primaryIfsc?.startsWith('DBSS')


  // useEffect(() => {
  //   openPaymentModal({
  //     onContinue: '/dashboard', // or any other route or function
  //     onRetry: handleRetryPayment,
  //     status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
  //     loading: true,
  //     paymentData: {
  //       amount: toCurrency(paymentPayload?.lumpsumAmount),
  //       paymentMode: 'Net-Banking',
  //       date: new Date().toLocaleDateString('en-IN', {
  //         day: '2-digit',
  //         month: 'short',
  //         year: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //       }),
  //     },
  //   })
  // }, [])

  const getSingleBankAccountNo = () =>
    bankAccountsList.length === 1 ? bankAccountsList[0].accountNo : null

  const handlePaymentMode = (option) => {
    setSelectedOption(option)
    setSelectedBank(getSingleBankAccountNo())
  }

  const openPaymentModal = (data) => {
    setModalData(data)
    setShowPaymentModal(true)
  }

  const closePaymentModal = () => {
    setShowPaymentModal(false)
    setModalData({})
    setLoading(false)
  }

  const paymentStatus = async (orders) => {
    try {
      const payload = {
        clientCode,
        orderNo: orderNo,
        isBasketOrder: true,
        customerBasketInvestmentIds: paymentPayload?.basketIds,
      }

      const response = await post('/mutualfundservice/api/bseStar/mfUpload/paymentStatus', payload)

      if (response.isError) {
        setMessageModalState({
          message: response?.response?.message,
          severity: 'error',
        })
      }

      if (
        (!response.isError &&
          response.status === 'SUCCESS' &&
          response.data !== 'PAYMENT NOT INITIATED FOR GIVEN ORDER') ||
        response.data === 'APPROVED ( UPI )'
      ) {
        setShowPaymentRequestPopup(false)

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          status: 'success', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'UPI', // could be "Credit Card", "UPI", etc.
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })

        // onOpen('openActionPlanPopup', {
        //   severity: 'success',
        //   title: '',
        //   message:
        //     'Your UPI payment has been successfully processed. The amount has been debited from your account and credited to the recipient.',
        //   severity: 'success',
        //   redirectTo: '/dashboard/mutual-funds/orders',
        //   goBack: '/dashboard',
        // })
      }

      if (
        !response.isError &&
        response.status === 'SUCCESS' &&
        response.data === 'PAYMENT NOT INITIATED FOR GIVEN ORDER'
      ) {
        setShowPaymentRequestPopup(false)

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'UPI', // could be "Credit Card", "UPI", etc.
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })

        // showError(
        //   'UPI Payment Failed',
        //   'Payment Failed. Unfortunately, your UPI transaction could not be completed. Please try again or use an alternate payment method.',
        //   () => navigate(-1),
        // )
      }
    } catch (error) {
      console.log('🚀 ~ paymentStatus ~ error:', error)

      openPaymentModal({
        onContinue: '/dashboard', // or any other route or function
        onRetry: handleRetryPayment,
        status: 'failure', // possible values: "inprogress", "success", "failed", etc.
        paymentData: {
          amount: toCurrency(paymentPayload?.lumpsumAmount),
          paymentMode: 'UPI',
          date: new Date().toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }),
        },
      })
    }
  }

  const oneTimeOrderPayment = async () => {
    try {
      setIsLoading(true)

      const orderNumber = paymentPayload?.orders?.map((order) => order?.orderNumber)

      setOrderNo(orderNumber)

      const totalAmount = paymentPayload?.orders?.reduce(
        (acc, order) => acc + Number(order.orderVal),
        0,
      )

      if (selectedOption === 'UPI' && !upiId) {
        showError('Missing UPI ID', 'Please enter a valid UPI ID to proceed.')
        setIsLoading(false)
        return
      }

      // Require user to choose which bank account is being used
      // (UPI id is linked to a specific bank account as well)
      if (!selectedBank) {
        showError('Select bank account', 'Please select the bank account to proceed.')
        setIsLoading(false)
        return
      }

      const payload = {
        orderNumber,
        totalAmount,
        clientCode,
        accountNo: selectedBank,
        bankName: bankAccountsList?.find((bank) => bank.accountNo === selectedBank)?.bankName,
        ifscCode: bankAccountsList?.find((bank) => bank.accountNo === selectedBank)?.ifscCode,
      }

      if (selectedOption === 'UPI') {
        payload.upiId = upiId
        payload.modeOfPayment = 'UPI'
        payload.loopbackURL = ''
      } else if (selectedOption === 'Cheque') {
        payload.modeOfPayment = 'CHEQUE'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/actionplan/one-time-payment/status`
      } else if (selectedOption === 'OTM') {
        payload.modeOfPayment = 'OTM'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/actionplan/one-time-payment/status`
      } else {
        payload.modeOfPayment = 'DIRECT'
        payload.loopbackURL = `${env.LOOPBACK_URL}dashboard/actionplan/one-time-payment/status`
      }

      const response = await post(
        `${env.API_URL}mutualfundservice/api/bseStar/api/oneTimePayment?newVersion=true`,
        payload,
      )

      setIsLoading(false)

      if (response.isError) {
        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'Net Banking',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })

        // showError(
        //   selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
        //   'Payment could not be processed at the moment. Please try later.',
        //   () => {},
        // )
      }

      if ((response?.status === 'SUCCESS') & (selectedOption === 'UPI')) {
        // onOpen('openPopup', {
        //   message: response.data.responsestring,
        //   severity: 'success',
        //   callback,
        // })
        setShowPaymentRequestPopup(true)
      }

      if (
        response?.status === 'SUCCESS' &&
        selectedOption !== 'UPI' &&
        selectedOption !== 'Cheque' &&
        payload.modeOfPayment !== 'UPI' &&
        response?.data?.responsestring
      ) {
        setResponseString(response?.data?.responsestring)
        // openBankPaymentResponse(response?.data?.responsestring)
        localStorage.setItem(
          'actionPlanPaymentStatusData',
          JSON.stringify({
            response: response?.data?.responsestring,
            clientCode,
            orderNo: orderNumber,
            basketIds: paymentPayload?.basketIds,
            amount: paymentPayload?.lumpsumAmount,
          }),
        )
        navigate('/dashboard/one-time-payment/status', {
          state: {
            response: response?.data?.responsestring,
            clientCode,
            orderNo: orderNumber,
          },
        })
      }

      if (
        response?.status === 'SUCCESS' &&
        selectedOption == 'Cheque' &&
        payload.modeOfPayment === 'CHEQUE' &&
        response?.message?.includes('One-time payment will be processed using cheque')
      ) {
        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'Cheque | RTGS | NEFT',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })



        // onOpen('openActionPlanPopup', {
        //   severity: 'info',
        //   title: 'Your order has been placed',
        //   message: 'Your Relationship Manager will stay in touch with you.',
        //   redirectTo: '/dashboard',
        //   goBack: '/dashboard',
        // })
        return
      }


      if (
        response?.status === 'SUCCESS' &&
        selectedOption == 'OTM' &&
        payload.modeOfPayment === 'OTM' &&
        response?.message?.includes('One-time payment will be processed using cheque or otm')
      ) {
        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'inprogress', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'OTM',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })



        // onOpen('openActionPlanPopup', {
        //   severity: 'info',
        //   title: 'Your order has been placed',
        //   message: 'Your Relationship Manager will stay in touch with you.',
        //   redirectTo: '/dashboard',
        //   goBack: '/dashboard',
        // })
        return
      }

      if (response?.status === 'FAILURE') {
        // showError(
        //   selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
        //   response.data.responsestring,
        //   () => navigate(-1),
        // )

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: 'Net Banking',
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })
      }

      if (response.isError) {
        // showError(
        //   selectedOption !== 'UPI' ? 'Payment Failed' : 'UPI Payment Failed',
        //   response.data.responsestring,
        //   () => navigate(-1),
        // )

        openPaymentModal({
          onContinue: '/dashboard', // or any other route or function
          onRetry: handleRetryPayment,
          status: 'failure', // possible values: "inprogress", "success", "failed", etc.
          paymentData: {
            amount: toCurrency(paymentPayload?.lumpsumAmount),
            paymentMode: selectedOption,
            date: new Date().toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            }),
          },
        })
      }
    } catch (error) {
      console.log('🚀 ~ placeOneTimeOrder ~ error:', error)
      openPaymentModal({
        onContinue: '/dashboard', // or any other route or function
        onRetry: handleRetryPayment,
        status: 'failure', // possible values: "inprogress", "success", "failed", etc.
        paymentData: {
          amount: toCurrency(paymentPayload?.lumpsumAmount),
          paymentMode: 'Net Banking',
          date: new Date().toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }),
        },
      })
    }
  }

  const handleRetryPayment = async (payload) => {
    try {
      setLoading(true)

      const response = await post(
        'mutualfundservice/api/basket/multiBasketOneTimeOrder',
        location?.state?.orderPayload,
      )

      if (response.isError) {
        closePaymentModal()
        setLoading(false)
        showError('', 'Unable to process your orders at this time. Please try again', () => { })
        return
      }

      if (response.status === 'SUCCESS') {
        const failures = response.basketResponses
          .map((response) => {
            const failedOrders = response.orders.filter((order) => order.status === 'FAILURE')
            return failedOrders.length > 0 ? { ...response, orders: failedOrders } : null
          })
          ?.filter((response) => response !== null)

        if (failures.length) {
          setLoading(false)
          showError('', 'Unable to process your orders at this time. Please try again', () => { })
          return
        }

        const basketIds = location?.state?.orderPayload?.map(
          (basket) => basket.customerBasketInvestmentId,
        )

        const orders =
          response?.basketResponses?.length > 0
            ? response?.basketResponses?.flatMap((basket) => basket.orders)
            : []

        sessionStorage.setItem('oneTimeActionPlanOrders', JSON.stringify(orders))

        const lumpsumAmount = location?.state?.paymentPayload?.lumpsumAmount

        const paymentPayload = {
          clientCode: clientCode?.toUpperCase(),
          orders: orders,
          lumpsumAmount: lumpsumAmount,
          basketIds: basketIds,
        }

        setPaymentPayload(paymentPayload)
        setLoading(false)
        closePaymentModal()
      } else {
        closePaymentModal()
        setLoading(false)
        showError('Try again later.', response?.response, () => { })
      }
    } catch (error) {
      closePaymentModal()
      console.log('🚀 ~ placeOneTimeRetryOrder ~ error:', error)
      setLoading(false)
      showError('', 'Unable to process your orders at this time. Please try again', () => { })
    }
  }

  const getMandateDetails = async () => {
    const response = await get('mutualfundservice/api/mutualFund/mandates')

    const approved =
      response?.status === 'SUCCESS' && Array.isArray(response?.data)
        ? response.data.filter((m) => m?.mandateStatus === 'APPROVED')
        : []

    setMandateDetails(approved)
  }

  const generateOTP = async () => {
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: userDetails?.phoneNumber,
        email: userDetails?.email,
      },
    )

    if (response.isError) {


      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => { })
    }

    if (!response.isError) {


      setOpenOTPPopup(true)
    }
  }


  const shouldShowOTMOption =
    Array.isArray(mandateDetails) &&
    mandateDetails.length > 0 &&
    mandateDetails.some((m) => Number(m?.amount) >= Number(paymentPayload?.lumpsumAmount))


  return (
    <>
      {showPaymentRequestPopup ? (
        <ActionPlanUpiRequest
          bankDetails={bankDetails}
          setShowPaymentRequestPopup={setShowPaymentRequestPopup}
          paymentStatus={paymentStatus}
          handleRetry={() =>
            openPaymentModal({
              onContinue: '/dashboard', // or any other route or function
              onRetry: handleRetryPayment,
              status: 'failure', // possible values: "inprogress", "success",
              // "failed", etc.
              paymentData: {
                amount: toCurrency(paymentPayload?.lumpsumAmount),
                paymentMode: 'UPI',
                date: new Date().toLocaleDateString('en-IN', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                }),
              },
            })
          }
        />
      ) : (
        <div className='bg-white'>
          <div className='max-w-[1128px] mx-auto'>
            <div
              className='flex gap-x-1 items-center font-semibold cursor-pointer lg:py-2.5 p-2 lg:px-0 bg-white'
              onClick={() => navigate(-1)}
            >
              <ChevronLeft className='h-5 w-5' />
              Complete Payment
            </div>

            <div className='flex items-center justify-center w-full bg-white mt-6'>
              <div className='w-full px-2 lg:w-[400px]'>
                <h1 className='font-dm-sans text-base font-medium leading-6 text-center decoration-slice text-black-500'>
                  Total payable amount
                </h1>
                <p className='font-dm-sans text-[32px] font-semibold leading-[42px] tracking-[-0.04em] text-center decoration-slice text-black-500 mt-2 mb-12'>
                  ₹ {toCurrency(paymentPayload?.lumpsumAmount)}
                </p>

                <p className='font-dm-sans p-2 font-medium leading-[20px] text-left decoration-slice text-[#2d2d2d]'>
                  Select a payment method
                </p>

                <div>
                  {/* UPI*/}
                  {paymentPayload?.lumpsumAmount <= 200000 && (
                    <div
                      onClick={() => handlePaymentMode('UPI')}
                      className={`border relative p-5 cursor-pointer rounded-[16px] mb-6 transition-all  duration-700 ease-out ${selectedOption === 'UPI'
                        ? 'border-2 border-primary-500 shadow-[0px_4px_24px_0px_rgba(65,85,141,0.12)] bg-[rgba(255,255,255,1)]'
                        : 'border-black-100'
                        }`}
                    >
                      <div className='flex justify-between items-center'>
                        <div className='flex items-center space-x-2'>
                          <span>
                            <img
                              src={scanner}
                              alt='Doc_Scanner'
                              className={
                                selectedOption === 'UPI' ? 'filter-none' : 'filter-grayscale'
                              }
                            />
                          </span>
                          <span
                            className={`font-dm-sans text-[20px] font-semibold leading-[28px] tracking-[-0.04em] text-centre decoration-slice ${selectedOption === 'UPI' ? 'text-primary-500' : 'text-[#727272]'
                              }`}
                          >
                            UPI
                          </span>
                          <span>
                            <img src={spark} alt='Spark' />
                          </span>
                        </div>
                        <span className='font-dm-sans text-sm font-medium leading-5 text-left text-black-300'>
                          Upto ₹ 2 Lakhs
                        </span>
                      </div>
                      {selectedOption === 'UPI' && (
                        <div className='mt-6 flex flex-col gap-y-6'>
                          <div>
                            {' '}
                            <label className='font-dm-sans text-[14px] font-medium leading-[20px] text-left decoration-slice text-black-500'>
                              Your UPI address
                            </label>
                            <Input
                              value={upiId}
                              onChange={(e) => setUpiId(e.target.value)}
                              type='text'
                              placeholder='address@bank'
                            />
                          </div>

                          <div className='space-y-2'>
                            <p className='font-dm-sans text-[13px] font-medium leading-[18px] text-left text-[#2d2d2d] mb-2'>
                              Select linked bank account to your UPI id
                            </p>
                            {bankAccountsList.map((bank) => (
                              <BankAccountItem
                                key={bank.accountNo}
                                bank={bank}
                                isSelected={selectedBank === bank.accountNo}
                                onSelect={setSelectedBank}
                                tickIcon={tick}
                                bankLogosUrl={env.BANK_LOGOS}
                              />
                            ))}
                          </div>

                          <p className='font-dm-sans text-sm font-medium leading-[20px] text-left decoration-slice text-[#2d2d2d]'>
                            Some banks may offer lesser limit, switch to Net Banking if UPI is
                            unsuccessful
                          </p>
                        </div>
                      )}

                      {Number(paymentPayload?.lumpsumAmount) < 200000 && (
                        <p className='absolute -top-3 right-5 inline-flex items-center gap-1 rounded-full border border-warning-600 bg-[#FFFBEB] px-3 py-1 text-[11px] font-medium text-warning-600'>
                          <span>Fastest</span>
                          <img src={spark} alt='Fastest' className='h-4 w-4' />
                        </p>
                      )}
                    </div>
                  )}

                  {/* Net Banking Option */}
                  {!disableNetBanking && (
                    <div
                      onClick={() => handlePaymentMode('NetBanking')}
                      className={`border p-5 cursor-pointer rounded-[16px] mb-6 transition-all duration-700 ease-out  ${selectedOption === 'NetBanking'
                        ? 'border-2 border-primary-500 shadow-[0px_4px_24px_0px_rgba(65,85,141,0.12)] bg-[rgba(255,255,255,1)]'
                        : 'border-black-100'
                        }`}
                    >
                      <div className='flex justify-between items-center '>
                        <div className='flex items-center space-x-2 '>
                          <span>
                            <img
                              src={selectedOption === 'NetBanking' ? additionalImage : account}
                              alt='account'
                            />
                          </span>
                          <span
                            className={`font-[DM Sans] text-xl font-medium leading-7 tracking-tight text-left ${selectedOption === 'NetBanking' ? 'text-[#41558d]' : 'text-[#727272]'
                              }`}
                          >
                            Net Banking
                          </span>
                        </div>
                        <span className='font-dm-sans text-sm font-medium leading-5 text-left text-[rgba(114,114,114,1)]'>
                          No limit
                        </span>
                      </div>
                      {selectedOption === 'NetBanking' && (
                        <div className='space-y-2 mt-4'>
                          <p className='font-dm-sans text-[13px] font-medium leading-[18px] text-left text-[#2d2d2d] mb-2'>
                            Select an account
                          </p>
                          {bankAccountsList.map((bank) => (
                            <BankAccountItem
                              key={bank.accountNo}
                              bank={bank}
                              isSelected={selectedBank === bank.accountNo}
                              onSelect={setSelectedBank}
                              tickIcon={tick}
                              bankLogosUrl={env.BANK_LOGOS}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Cheque Option */}

                  <div
                    onClick={() => handlePaymentMode('Cheque')}
                    className={`border p-5 cursor-pointer rounded-[16px] mb-6 transition-all duration-700 ease-out  ${selectedOption === 'Cheque'
                      ? 'border-2 border-primary-500 shadow-[0px_4px_24px_0px_rgba(65,85,141,0.12)] bg-[rgba(255,255,255,1)]'
                      : 'border-black-100'
                      }`}
                  >
                    <div className='flex justify-between items-center '>
                      <div className='flex items-center space-x-2 '>
                        <span>
                          <FileText
                            className={`${selectedOption === 'Cheque' ? 'text-[#41558d]' : 'text-[#727272]'
                              }`}
                          />
                        </span>
                        <span
                          className={`font-[DM Sans] text-xl font-medium leading-7 tracking-tight text-left ${selectedOption === 'Cheque' ? 'text-[#41558d]' : 'text-[#727272]'
                            }`}
                        >
                          Cheque | RTGS | NEFT
                        </span>
                      </div>
                      <span className='font-dm-sans text-sm font-medium leading-5 text-left text-[rgba(114,114,114,1)]'>
                        No limit
                      </span>
                    </div>
                    {selectedOption === 'Cheque' && (
                      <div className='space-y-2 mt-4'>
                        <p className='font-dm-sans text-[13px] font-medium leading-[18px] text-left text-[#2d2d2d] mb-2'>
                          Select an account
                        </p>
                        {bankAccountsList.map((bank) => (
                          <BankAccountItem
                            key={bank.accountNo}
                            bank={bank}
                            isSelected={selectedBank === bank.accountNo}
                            onSelect={setSelectedBank}
                            tickIcon={tick}
                            bankLogosUrl={env.BANK_LOGOS}
                          />
                        ))}
                      </div>
                    )}
                  </div>


                  {/* OTM Option */}

                  {shouldShowOTMOption && <div
                    onClick={() => handlePaymentMode('OTM')}
                    className={`border relative p-5 cursor-pointer rounded-[16px] mb-6 transition-all duration-700 ease-out  ${selectedOption === 'OTM'
                      ? 'border-2 border-primary-500 shadow-[0px_4px_24px_0px_rgba(65,85,141,0.12)] bg-[rgba(255,255,255,1)]'
                      : 'border-black-100'
                      }`}
                  >
                    <div className='flex justify-between items-center '>
                      <div className='flex items-center space-x-2 '>
                        <span>
                          <FileText
                            className={`${selectedOption === 'OTM' ? 'text-[#41558d]' : 'text-[#727272]'
                              }`}
                          />
                        </span>
                        <span
                          className={`font-[DM Sans] text-xl font-medium leading-7 tracking-tight text-left ${selectedOption === 'OTM' ? 'text-[#41558d]' : 'text-[#727272]'
                            }`}
                        >
                          One Time Mandate
                        </span>
                      </div>
                      <span className='font-dm-sans text-sm font-medium leading-5 text-left text-[rgba(114,114,114,1)]'>
                        No limit
                      </span>
                    </div>
                    {selectedOption === 'OTM' && (
                      <div className='space-y-2 mt-4'>
                        <p className='flex items-start gap-2 font-dm-sans text-[13px] font-medium leading-[18px] text-left text-warning-600 py-2 px-1'>
                          <AlertCircleIcon className='w-5 h-5 text-warning-600' />
                          <span>
                            Your money will be debited automatically within the next 2 working days.
                          </span>
                        </p>
                        <p className='font-dm-sans text-[13px] font-medium leading-[18px] text-left text-[#2d2d2d] mb-2'>
                          Select an account
                        </p>
                        {bankAccountsList.map((bank) => (
                          <BankAccountItem
                            key={bank.accountNo}
                            bank={bank}
                            isSelected={selectedBank === bank.accountNo}
                            onSelect={setSelectedBank}
                            tickIcon={tick}
                            bankLogosUrl={env.BANK_LOGOS}
                          />
                        ))}
                      </div>
                    )}

                    {Number(paymentPayload?.lumpsumAmount) > 200000 && (
                      <p className='absolute -top-3 right-5 inline-flex items-center gap-1 rounded-full border border-warning-600 bg-[#FFFBEB] px-3 py-1 text-[11px] font-medium text-warning-600'>
                        <span>Fastest</span>
                        <img src={spark} alt='Fastest' className='h-4 w-4' />
                      </p>
                    )}
                  </div>}

                  <Button
                    disabled={!selectedOption || !selectedBank || (selectedOption === 'UPI' && !upiId)}
                    loading={isLoading}
                    className='w-full p-2 rounded-lg bg-primary-500 disabled:bg-primary-300 font-dm-sans text-[14px] font-medium leading-[20px] text-center decoration-skip-ink-none text-white'
                    onClick={() =>
                      selectedOption === 'Cheque' ? setVerifyCheque(true) : selectedOption === 'OTM' ? generateOTP() : oneTimeOrderPayment()
                    }
                  >
                    Proceed
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <AlertDialog open={verifyCheque} onOpenChange={setVerifyCheque}>
        <AlertDialogContent className='h-auto min-h-[240px]'>
          <AlertDialogHeader>
            <AlertDialogTitle>Cheque, NEFT & RTGS</AlertDialogTitle>
            <AlertDialogDescription className='text-black-400'>
              Please ensure you have sent your cheque/NEFT/RTGS details to your relationship
              manager.
              <br />
              <br />
              Contact us at <strong>+91 9035189836</strong>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => oneTimeOrderPayment()}>Continue</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <PaymentStatusModal
        isOpen={showPaymentModal}
        onClose={closePaymentModal}
        onContinue={modalData.onContinue}
        onRetry={modalData.onRetry}
        status={modalData.status}
        loading={loading}
        paymentData={modalData.paymentData}
      />

      {openOTPPopup && (
        <OrderOtpVerification
          phoneNumber={userDetails?.phoneNumber}
          openOTPPopup={openOTPPopup}
          setOpenOTPPopup={setOpenOTPPopup}
          email={userDetails?.email}
          handleSipOrOT={oneTimeOrderPayment}
        />
      )}
    </>
  )
}

export default MFBasketOneTimePayment
